export var REDUCER_USER_CHANGE_PASSWORD_NAME = 'userChangePasswordReducer';
export var CHANGE_PASSWORD_URL = '/user/profile/change-password';
export var CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
var USER_PROFILE_CHANGE_PASSWORD_URL = '/user/change-password';
export { USER_PROFILE_CHANGE_PASSWORD_URL };